import { useState } from "react";

export const usePopupState = () => {
  const [popup, setPopup] = useState<any>({});

  return {
    popup,
    setPopup,
  };
};
